import { Box, Typography, IconButton } from '@mui/material'
import styled from '@emotion/styled/macro'
import theme from 'theme'

export const ModalOverlay = styled(Box)`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10002;
`

export const ModalContainer = styled(Box)`
  background-color: ${theme.colors.surfaceContainerBackground};
  border-radius: 12px;
  padding: 32px;
  width: 634px;
  height: 282px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`

export const ModalContent = styled(Box)`
  display: flex;
  flex-direction: column;
  gap: 32px;
`

export const ModalTitleRow = styled(Box)`
  display: flex;
  align-items: flex-start;
  gap: 8px;
`

export const ModalTitleWrapper = styled(Box)`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  padding-left: 50px;
`

export const ModalTitle = styled(Typography)`
  font-family: ${theme.typography.fontFamily.primary};
  font-size: 28px;
  font-weight: 500;
  color: ${theme.colors.foreground};
  text-align: center;
  line-height: 42px;
`

export const CloseButton = styled(IconButton)`
  color: ${theme.colors.textSecondary};
  padding: 9px;
  width: 42px;
  height: 42px;

  &:hover {
    background-color: rgba(255, 255, 255, 0.05);
  }

  &.Mui-disabled {
    color: ${theme.colors.textSecondary};
  }
`

export const InputWrapper = styled(Box)`
  position: relative;
  width: 100%;
`

export const InputLabel = styled(Box)`
  position: absolute;
  top: -6px;
  left: 12px;
  background-color: ${theme.colors.surfaceContainerBackground};
  padding: 0 4px;
  z-index: 1;
`

export const InputLabelText = styled(Typography)`
  font-family: ${theme.typography.fontFamily.primary};
  font-size: 12px;
  font-weight: 500;
  color: ${theme.colors.cardDateText};
  line-height: 12px;
`

export const TextInput = styled('input')`
  width: 100%;
  height: 48px;
  padding: 0 16px;
  background-color: transparent;
  border: 1px solid ${theme.colors.dropdownBorder};
  border-radius: 12px;
  font-family: ${theme.typography.fontFamily.primary};
  font-size: 14px;
  font-weight: 500;
  color: ${theme.colors.foreground};
  outline: none;

  &:focus {
    border-color: ${theme.colors.cardDateText};
  }

  &::placeholder {
    color: ${theme.colors.cardDateText};
  }
`

export const ModalActions = styled(Box)`
  display: flex;
  gap: 8px;
`

export const CancelButton = styled(Box)`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 13px 24px;
  border: 1px solid ${theme.colors.dropdownBorder};
  border-radius: 12px;
  cursor: pointer;

  &:hover {
    background-color: rgba(255, 255, 255, 0.05);
  }
`

export const CancelButtonText = styled(Typography)`
  font-family: ${theme.typography.fontFamily.primary};
  font-size: 14px;
  font-weight: 500;
  color: ${theme.colors.textSecondary};
  line-height: 22px;
`

export const SaveButton = styled(Box)`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 13px 24px;
  background-color: ${theme.colors.cta};
  border-radius: 12px;
  cursor: pointer;

  &:hover {
    opacity: 0.9;
  }
`

export const SaveButtonText = styled(Typography)`
  font-family: ${theme.typography.fontFamily.primary};
  font-size: 14px;
  font-weight: 500;
  color: ${theme.colors.surfaceContainerBackground};
  line-height: 22px;
`
